module.exports = __webpack_public_path__ + "media/images/messagecards/yellow-bdfb69e5b92d2427c67eb6b15f17d618.jpg";